<template>
  <Panel header="Program Dashboard" class="mb-4 w-full">
    <div class="grid grid-cols-12">
      <div class="col-span-3 m-2">
        <InventoryByNodePieChart :program="program" />
      </div>
      <div class="col-span-3 m-2">
        <InventoryAccuracyPieChart :program="program" />
      </div>
      <div class="col-span-6 m-2">
        <InventoryHistoryBarChart :program="program" />
      </div>
      <div class="col-span-6 m-2">
        <TurnsHistoryBarChart :program="program" />
      </div>
      <div class="col-span-2 m-2">
        <CalculateTurnsWidget :program="program" />
      </div>
    </div>
  </Panel>
</template>

<script>
import Panel from 'primevue/panel'
import InventoryByNodePieChart from '@/components/charts/InventoryByNodePieChart.vue'
import InventoryAccuracyPieChart from '@/components/charts/InventoryAccuracyPieChart.vue'
import InventoryHistoryBarChart from '@/components/charts/InventoryHistoryBarChart.vue'
import TurnsHistoryBarChart from '@/components/charts/TurnsHistoryBarChart.vue'
import CalculateTurnsWidget from '@/components/kpis/CalculateTurnsWidget.vue'

export default {
  components: {
    Panel,
    InventoryByNodePieChart,
    InventoryAccuracyPieChart,
    InventoryHistoryBarChart,
    TurnsHistoryBarChart,
    CalculateTurnsWidget
  },
  props: {
    program: {
      type: Object,
      default: () => {}
    }
  },
  setup() {
    return {}
  },
}
</script>
